import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import './TripleColumn.css';

const TripleColumn = ({ onOpenModal }) => (
  <div className="section wcuSection">
    <Container className="custom-container">
      <Row>
        <Col>
          <p className="h2">Why choose us?</p>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex align-items-stretch">
          <div className="wcuCard">
            <p className="wcuCardText">25 Years of Expertise</p></div>
        </Col>
        <Col className="d-flex align-items-stretch">
          <div className="wcuCard">
            <p className="wcuCardText">Locally Owned</p></div>
        </Col>
        <Col className="d-flex align-items-stretch">
          <div className="customCard wcuCard">
            <p className="wcuCardText">Family Operated</p></div>
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="body-lg">We specialize in tinting homes, businesses, and RVs. Our tints offer glare reduction, heat control, interior protection, energy savings, added privacy, security, and even EMF reduction. Every property is unique, let us show you films best for you.</p>
          <p className="body-lg">We proudly serve Flagstaff, Cottonwood, Sedona, Cornville, Camp Verde, Village of Oak Creek, Rimrock/Lake Montezuma, and the surrounding areas. Contact us today for a consultation!</p>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-center">
          <Button onClick={onOpenModal}>Request an Estimate</Button>
        </Col>
      </Row>
    </Container>
  </div>
);

export default TripleColumn;
